import styled from 'styled-components'
import Note from 'components/Note'

const ErrorLinksTitle = styled(Note)`
  margin-top: 40px;
  margin-bottom: 4px;
`

export default ErrorLinksTitle
